<svg style="background:var(--anatomy-gray-100); padding: 40px 10px" height="160" viewBox="0 0 200 160">
  <rect id="Placement_Area" data-name="Placement Area" width="200" height="160" fill="red" opacity="0"/>
  <g id="Container" fill="var(--anatomy-gray-50)" stroke="var(--anatomy-gray-400)" stroke-width="1">
    <rect width="200" height="160" rx="4" stroke="none"/>
    <rect x="0.5" y="0.5" width="199" height="159" rx="3.5" fill="none"/>
  </g>
  <g id="Visible_Items">
    <g id="Item_1" transform="translate(8 8)">
      <rect width="176" height="28" rx="2" fill="var(--anatomy-gray-200)"/>
      <rect x="8" y="10" width="80" height="8" rx="2" fill="var(--anatomy-gray-600)"/>
    </g>
    <g id="Item_2" transform="translate(8 40)">
      <rect width="176" height="28" rx="2" fill="var(--anatomy-gray-200)"/>
      <rect x="8" y="10" width="100" height="8" rx="2" fill="var(--anatomy-gray-600)"/>
    </g>
    <g id="Item_3" transform="translate(8 72)">
      <rect width="176" height="28" rx="2" fill="var(--anatomy-gray-200)"/>
      <rect x="8" y="10" width="90" height="8" rx="2" fill="var(--anatomy-gray-600)"/>
    </g>
    <g id="Item_4_Partial" transform="translate(8 104)">
      <rect width="176" height="28" rx="2" fill="var(--anatomy-gray-200)"/>
      <rect x="8" y="10" width="110" height="8" rx="2" fill="var(--anatomy-gray-600)"/>
    </g>
    <g id="Item_5_Partial" transform="translate(8 136)" opacity="0.5">
      <rect width="176" height="20" rx="2" fill="var(--anatomy-gray-200)"/>
      <rect x="8" y="6" width="70" height="8" rx="2" fill="var(--anatomy-gray-600)"/>
    </g>
  </g>
  <g id="Scrollbar">
    <rect x="188" y="8" width="4" height="144" rx="2" fill="var(--anatomy-gray-200)"/>
    <rect x="188" y="8" width="4" height="40" rx="2" fill="var(--anatomy-gray-600)"/>
  </g>
</svg>
